// src/components/SlideOutPanel.js
import React from 'react';
import { motion } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import { useDarkMode } from '../context/DarkModeContext';

const SlideOutPanel = ({ isOpen, onClose, children }) => {
  const { darkMode } = useDarkMode();
  return (
    <motion.div
      initial={{ x: '100%' }}
      animate={{ x: isOpen ? 0 : '100%' }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      className="fixed top-0 right-0 w-full sm:w-96 h-full bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 shadow-lg z-50 overflow-y-auto border-l border-gray-100 dark:border-gray-800 transition-colors duration-300"
    >
      <div className="p-4">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl hover:text-gray-500 dark:hover:text-gray-300 transition-colors"
        >
          <FiX />
        </button>
        {children}
      </div>
    </motion.div>
  );
};

export default SlideOutPanel;